import React from 'react';
import { CreateAgencyWizardStepProps } from '../types';
import AgencyCoordinatorsForm, { AgencyCoordinatorsFormModel } from '../../../components/agency-coordinators-form/AgencyCoordinatorsForm';

const AgencyCoordinatorsWizardStep: React.FC<CreateAgencyWizardStepProps> = ({
  initialData,
  loading = false,
  formRef,
  onSubmit,
}) => {
  const onInternalSubmit = React.useCallback(({
    coordinators,
  }: AgencyCoordinatorsFormModel) => {
    // TODO: Fix the type in bricks
    const isFormDirty = (formRef?.current as any)?.dirty ?? false;

    onSubmit({
      ...initialData,
      coordinatedBy: coordinators.map(({ email }) => email.work || email.personal),
    }, isFormDirty);
  }, [formRef, initialData, onSubmit]);

  if (!initialData) return null;

  return (
    <AgencyCoordinatorsForm
      agency={initialData}
      initialValues={{
        // we are not fetching existing agents cause we are inside the wizard to create a new agency
        // so there won't be any
        coordinators: [],
      }}
      innerRef={formRef}
      onSubmit={onInternalSubmit}
      loading={loading}
    />
  );
};

export default AgencyCoordinatorsWizardStep;
